import { HttpClient, HttpContext, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface McpRelayRequestOptions {
  headers?: HttpHeaders | Record<string, string | string[]>;
  params?: HttpParams | Record<string, string | number | boolean>;
  context: HttpContext;
}

@Injectable({
  providedIn: 'root',
})
export class McpRelayService {
  private readonly relayUrl = environment.mcpApiUrl;

  constructor(private readonly httpClient: HttpClient) {}

  health(): Observable<unknown> {
    return this.httpClient.get(`${this.relayUrl}/relay-health`);
  }

  post<TResponse = unknown>(payload: unknown, options?: McpRelayRequestOptions): Observable<TResponse> {
    return this.httpClient.post<TResponse>(`${this.relayUrl}/query`, payload, options);
  }

  request<TResponse = unknown>(
    method: string,
    path = '',
    body?: unknown,
    options?: McpRelayRequestOptions,
  ): Observable<TResponse> {
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;

    return this.httpClient.request<TResponse>(method, `${this.relayUrl}${normalizedPath}`, {
      body,
      headers: options?.headers,
      params: options?.params,
    });
  }
}
